document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-accordion]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const select = productForm.querySelector('select[name="id"]');
    const price = document.querySelector('[data-product-price]');
    if (select && price) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (option.dataset.price) price.textContent = option.dataset.price;
      });
    }
  }
});
